import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import i18n from "../i18n";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const applyLanguage = (lang) => {
    if (!lang) return;
    const supported = ["en", "es", "fr", "de", "pt", "it"];
    const code = (lang || "").split("-")[0];
    if (supported.includes(code) && i18n.language !== code) {
      i18n.changeLanguage(code);
      try { localStorage.setItem("tlb_lang", code); } catch (e) { /* noop */ }
    }
  };

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setUser(res.data);
      applyLanguage(res.data?.language);
    } catch (e) {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = useCallback(async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {}
    try { localStorage.removeItem("session_token"); } catch (e) {}
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, setUser, loading, checkAuth, refresh: checkAuth, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
